/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Defines the kinds of entities that can own attributes within the application.
 * Use this enumeration to specify or determine the type of entity associated with a set of
 * attributes, such as customers, projects, or project line items. This helps categorize and manage attributes
 * according to the entity they belong to.
 */
export enum Shared_AttributeOwnerEntityKinds {
    /**
     * Represents a customer
     */
    Customer = 10,
    /**
     * Represents a project entity type within the application owned by a customer.
     */
    Project = 20,
    /**
     * Represents a lineitem in a project, used to tracking systems within a project.
     */
    ProjectLineItem = 30,
    /**
     * Used for filtering the main list for adding products to a project
     */
    FilterAttribute = 40,
    /**
     * Represents a shared attribute that is a kind of "super attribute", foremost placed on the highest
     * configurationitem for setting values to use in the lower configurationitems. This is used for attributes that are shared across
     * multiple entities or configurations, allowing for centralized management and consistency of attribute values.
     * Used foremost together with
     */
    SharedAttribute = 50,
}
